import React from 'react'
import ModalBasic from '../../component/ModalBasic';
import { AgGridReact } from "ag-grid-react";

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "drawingNo",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "pendingQty",
        headerName: "Pending qty",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "woRecvNo",
        headerName: "WO recv no",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

function PendingWoData(props) {
    return (
        <ModalBasic
            id="pending-wo-data"
            classParams="!w-[60%] overflow-y-auto p-5 pt-2.5"
            modalOpen={props.isPendingOpen}
            setModalOpen={props.setPendingModel}
        >
            <div className="pending-table h-[55vh] pt-2.5">
                <span className="text-blue text-[16px] font-semibold">Work order data</span>
                <div className="table-inner mt-[10px] overflow-y-auto"
                style={{height: "calc(100vh - 370px)"}}>
                    <AgGridReact
                        rowData={props.pendingRowData}
                        columnDefs={itemColdefs}
                    // onCellClicked={props.handleCellClickItemList}
                    //onGridReady={props.onGridReady}
                    //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                    //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                    />
                </div>
            </div>

        </ModalBasic>
    )
}

export default PendingWoData